// @flow
import * as React from 'react';
import {
  NoData, useCallHistoryItemsQuery
} from '../../../../shared';
import {
  CircularProgress,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { useClient } from '../../hooks/client-context';
import { CallsList } from './ui/calls-list';
import { Refresh, Add } from '@mui/icons-material';
import { useCallForm, withCallForm } from './ui/call-form-modal';
import { keycloak, KeycloakRoles } from '@coverright/shared/keycloak';

export const Calls = () => {
  const client = useClient();
  const {data, refetch, loading } = useCallHistoryItemsQuery({
    variables: {clientId: client.id, page: {page: 0, size: 50}},
    skip: !client.id,
    notifyOnNetworkStatusChange: true
  })

  const calls = data?.callHistoryItems.data;
  return (
    <Stack gap={2}>
      <Stack gap={2} direction={'row'} alignItems={'center'} flex={1} minHeight={32}>
        <Typography variant={'subtitle1'} flex={1}>Call history</Typography>

        <Stack gap={2} direction={'row'} alignItems={'center'}>
          <AddCallButton />

          {!loading && <IconButton
            size={'small'}
            onClick={() => refetch()}>
            <Refresh color={'action'}/>
          </IconButton>}
          {loading && <CircularProgress size={20} />}
        </Stack>
      </Stack>

      {!calls?.length && <NoData>{loading ? 'Loading...' : 'No data'}</NoData>}
      {!!calls?.length && <CallsList onChange={refetch} calls={calls}
                                     loading={loading} />}
    </Stack>
  )
};

const AddCallButton = withCallForm(() => {
  const client = useClient();
  const {open} = useCallForm();
  const isTechManager = keycloak?.hasRealmRole(KeycloakRoles.ROLE_TECH_STAFF)

  /*if (!isTechManager) {
    return null;
  }*/

  return (
    <IconButton
      size={'small'}
      onClick={() => client && open(client)}>
      <Add color={'action'}/>
    </IconButton>
  )
})
